import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const AddonsApi = createApi({
  reducerPath: "AddonsApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["ADDONSAPI"],
  endpoints: (build) => ({
    getAddons: build.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        type = "",
        isActive = "",
      }) => ({
        url: `/addon?page=${page}&limit=${limit}&search=${search}&type=${type}&isActive=${isActive}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["ADDONSAPI"],
    }),

    getAddonById: build.query({
      query: ({ id }) => ({
        url: `/addon/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["ADDONSAPI"],
    }),

    createAddon: build.mutation({
      query: ({ data }) => ({
        url: `/addon`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["ADDONSAPI"],
    }),

    updateAddon: build.mutation({
      query: ({ id, data }) => ({
        url: `/addon/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["ADDONSAPI"],
    }),

    deleteAddon: build.mutation({
      query: ({ id }) => ({
        url: `/addon/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["ADDONSAPI"],
    }),
  }),
});

export const {
  useGetAddonsQuery,
  useGetAddonByIdQuery,
  useCreateAddonMutation,
  useUpdateAddonMutation,
  useDeleteAddonMutation,
  useLazyGetAddonsQuery,
  useLazyGetAddonByIdQuery,
} = AddonsApi;
